import './StoryLanding.sass';
import '../StoryViewer/StoryViewer.sass';
import '../../shared/components/Story/Story.sass';

import React, { FC, MouseEvent, useCallback, useEffect, useState } from 'react';
import { useSpring } from '@react-spring/web';
import { useRoute } from 'react-router5';

import { StoryPlayer, StoryProgress } from '$shared/components';
import { Button } from '$uikit';
import { classNames, statReachGoal } from '$utils';
import { IcSoundOff24, IcSoundOn24 } from '$assets';
import { useDispatch, useSelector } from 'react-redux';
import { AuthPopoverSimple } from '$core/AuthPopover/AuthPopover';
import { profileActions } from '$store/profile';
import { AuthPopoverState } from '$store/models';
import { authSelector } from '$store/auth';

const Landings = {
  1: [
    {
      id: 1,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster1.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story1.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 2,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster2.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story2.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 3,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster3.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story3.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 4,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster4.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story4.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 5,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster5.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story5.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 6,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster6.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story6.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 7,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/poster7.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/1/story7.mp4',
      unread: false,
      duration: 10,
    },
  ],
  2: [
    {
      id: 1,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/poster1.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/story1.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 2,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/poster2.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/story2.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 3,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/poster3.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/story3.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 4,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/poster4.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/story4.mp4',
      unread: false,
      duration: 10,
    },
    {
      id: 5,
      userId: 1,
      createdAt: Date.now(),
      type: 'video',
      thumbnail:
        'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/poster5.jpeg',
      mediaUrl: 'https://tonplace.ams3.cdn.digitaloceanspaces.com/stories/2/story5.mp4',
      unread: false,
      duration: 10,
    },
  ],
};

export const StoryLanding: FC = () => {
  const { route } = useRoute();
  const id = route.params.id;
  const dispatch = useDispatch();
  const stories = Landings[id];
  const [index, setIndex] = useState(0);
  const [sound, setSound] = useState(false);
  const { isLogged } = useSelector(authSelector);

  useEffect(() => {
    statReachGoal('story_landing_visit', {
      id,
    });
    statReachGoal(`story_landing_visit_${id}`);

    if (isLogged) {
      location.href = '/feed';
    }
  }, []);

  const [{ progress }, api] = useSpring(() => ({ progress: 0 }));

  const ratio = 2160 / 1080;
  const width = Math.min(400, window.innerWidth);
  const height = width * ratio;
  const marginTop = window.innerHeight < height ? -(height - window.innerHeight) / 2 : 0;

  const storyId = stories[index].id;
  const story = stories[index];

  const handleJoin = useCallback(() => {
    if (isLogged) {
      location.href = '/feed';
      return;
    }

    statReachGoal('story_landing_press_join', {
      id,
    });

    statReachGoal(`story_landing_press_join_${id}`);

    dispatch(profileActions.setAuthPopoverState(AuthPopoverState.REGISTER));
  }, [id, isLogged]);

  const onEnd = useCallback(() => {
    setIndex((curVal) => Math.min(curVal + 1, stories.length - 1));

    if (index + 1 >= stories.length) {
      handleJoin();
    }
  }, [stories, index, handleJoin]);

  const handlePrev = useCallback(() => {
    setIndex((curVal) => Math.max(curVal - 1, 0));
  }, []);

  const handleSoundToggle = (e: MouseEvent<HTMLDivElement>) => {
    setSound(!sound);
  };

  return (
    <>
      <div
        className="StoryLanding"
        style={{
          width,
          height,
        }}
      >
        <div className="StoryLanding__touch_zones">
          <div className="StoryLanding__touch_zones__prev" onClick={handlePrev} />
          <div className="StoryLanding__touch_zones__next" onClick={onEnd} />
        </div>
        <div className="StoryLanding__top">
          <StoryProgress
            key={storyId}
            total={stories.length}
            current={index}
            animation={progress}
          />
        </div>
        <div className="StoryLanding__cont" style={{ marginTop, height }}>
          <StoryPlayer
            key={storyId}
            onEnd={onEnd}
            story={story}
            muted={!sound}
            disableAutoplay
            animation={api}
          />
        </div>
        <div
          className={classNames({
            StoryLanding__button: true,
            shown: stories.length - 1 === index,
          })}
        >
          <Button flare onClick={handleJoin}>
            Join now
          </Button>
        </div>
        <div className="Story__header" style={{ zIndex: 4 }}>
          <div className="Story__actions">
            {story.type === 'video' && (
              <div
                onPointerDown={handleSoundToggle}
                className="Story__actions__item Story__sound"
              >
                {sound ? <IcSoundOn24 /> : <IcSoundOff24 />}
              </div>
            )}
          </div>
        </div>
        <div className="StoryViewer__preloader">
          {stories.slice(index + 1, index + 3).map((story, i) => {
            if (story.type === 'video') {
              return (
                <div key={story.mediaUrl}>
                  <img key={i} src={story.thumbnail} />
                  <video
                    muted={true}
                    controls={false}
                    preload="auto"
                    disablePictureInPicture
                    playsInline
                  >
                    <source src={story.mediaUrl} type="video/mp4,video/quicktime" />
                  </video>
                </div>
              );
            } else {
              return <img key={i} src={story.mediaUrl} />;
            }
          })}
        </div>
      </div>
      <AuthPopoverSimple />
    </>
  );
};
